// eslint-disable-next-line import/no-cycle
import templatesApi from '../api/templatesApi';
import * as rootTypes from '@/store/types';

import * as types from './types';

const actions = {
  [types.FETCH_TEMPLATES_SEARCH]: (context, { params = {}, filters = {} }) => {
    const {
      page,
      perPage,
      sortBy,
      sortDesc,
    } = params;
    const orderDirection = (sortDesc) ? 'DESC' : 'ASC';
    let url = '';
    // /creative-templates/search?[page={2}&pageSize={20}&search={search}&sortBy={sortBy}&sortDirection={ASC|DESC}]
    // /creative-templates/search?[page={page}&pageSize={pageSize}&search={search}&sortBy={sortBy}&sortDirection={ASC|DESC}]
    if (page) {
      url = `${url}&page=${page}`;
    }
    if (perPage) {
      url = `${url}&pageSize=${perPage}`;
    }
    if (sortBy) {
      url = `${url}&sortBy=${sortBy}&sortDirection=${orderDirection}`;
    }
    // if (filters && filters.size) {
    //   const { size } = filters;
    //   url = `${url}&size=${size}`;
    // }
    // if (filters && filters.type) {
    //   const { type } = filters;
    //   url = `${url}&type=${type}`;
    // }
    if (filters && filters.name) {
      const { name } = filters;
      url = `${url}&search=${encodeURIComponent(name)}`;
    }
    return templatesApi
      .getTemplates(url)
      .then((response) => response);
  },
  [types.FETCH_CREATIVE_TYPES]: () => templatesApi
    .getCreativeTypes()
    .then((response) => response),
  [types.FETCH_TEMPLATE]: (context, payload) => templatesApi
    .getTemplate(payload)
    .then((response) => response),
  [types.UPDATE_TEMPLATE]: (context, payload) => {
    let promise;
    if (payload.id) {
      promise = templatesApi.updateTemplate(payload.id, payload);
    } else {
      promise = templatesApi.createTemplate(payload);
    }
    return promise.then((response) => {
      context.commit(
        rootTypes.SET_GLOBAL_MESSAGE,
        {
          message: 'The template was successfully saved',
          type: 'success',
        },
        { root: true },
      );
      return response.data;
    });
  },
  [types.FETCH_TEMPLATE_GROUPS]: (context, payload) => templatesApi
    .getTemplateGroups(payload)
    .then((response) => response),
  [types.CREATE_NEW_TEMPLATE_GROUP]: (context, payload) => templatesApi
    .createTemplateGroup({ name: payload })
    .then((response) => response.data),
  [types.FETCH_TEMPLATES_IN_GROUP_ID]: (context, payload) => templatesApi
    .getTemplatesInGroupId(payload)
    .then((templateList) => {
      const { creatives } = context.rootState.content;
      if (creatives.length > 0) {
        const filteredCreatives = creatives
          .filter((item) => item.paused === false)
          .map((item) => item.creativeTemplateId);
        context.commit(types.SET_SELECTED_TEMPLATES, filteredCreatives);
      } else {
        context.commit(types.SET_SELECTED_TEMPLATES, templateList.map((item) => item.id));
      }
      return templateList;
    }),
  [types.SET_SELECTED_TEMPLATES]: (context, payload) => {
    context.commit(types.SET_SELECTED_TEMPLATES, payload);
  },
  [types.UPDATE_SELECTED_TEMPLATES]: (context, payload) => {
    context.commit(types.UPDATE_SELECTED_TEMPLATES, payload);
  },
  [types.CHANGE_SELECTED_CREATIVE_TEMPLATE_GROUP]: (context, payload) => {
    context.commit(types.CHANGE_SELECTED_CREATIVE_TEMPLATE_GROUP, payload);
  },
};

export default actions;
